export default function Modal(props) {
  const {
    handleSubmit,
    setShowModal,
    child,
    title,
    isSubmitButton = false,
  } = props;

  return (
    <div>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none ">
        <div className="relative mx-auto my-6 w-auto max-w-3xl">
          <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
            <div className="border-slate-200 flex items-start justify-between rounded-t border-b border-solid p-5">
              <h3 className="text-3xl font-semibold">{title}</h3>
              <button
                className="float-right ml-auto border-0 p-1 text-3xl font-semibold leading-none text-black outline-none focus:outline-none"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>
            {/*body*/}
            <div className="relative max-h-96 flex-auto overflow-x-hidden overflow-y-hidden p-6">
              {child}
            </div>
            {/*footer*/}
            <div className="border-slate-200 flex items-center justify-end rounded-b border-t border-solid p-6">
              <button
                className="active:bg-emerald-600 mb-1 mr-1 rounded bg-orange-400 px-6 py-3 text-sm font-bold uppercase text-white shadow outline-none transition-all duration-150 ease-linear hover:shadow-lg focus:outline-none"
                type={isSubmitButton ? "submit" : "button"}
                onClick={() => {
                  handleSubmit();
                  setShowModal(false);
                }}
              >
                Тийм
              </button>
              <button
                className="background-transparent mb-1 mr-1 px-6 py-2 text-sm font-bold uppercase text-orange-400 outline-none transition-all duration-150 ease-linear focus:outline-none"
                type="button"
                onClick={() => setShowModal(false)}
              >
                Үгүй
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </div>
  );
}
